(function () {
  function init(root) {
    if (!root || root.dataset.dkReady) return;
    root.dataset.dkReady = '1';
    var form = root.querySelector('[data-dk-form]');
    if (!form) return;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var tiers = [];
    try { tiers = JSON.parse(root.dataset.tiers || '[]'); } catch (e) {}
    tiers.sort(function (a, b) { return a.n - b.n; });
    var MAX = 10;

    var mf = (root.dataset.moneyFormat || '{{amount_with_comma_separator}} TL').replace(/<[^>]*>/g, '');
    var group = function (n, d, t, s) {
      var p = (Math.round(n) / 100).toFixed(d).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (p[1] ? s + p[1] : '');
    };
    var fmt = function (c) {
      return mf.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        switch (k) {
          case 'amount': return group(c, 2, ',', '.');
          case 'amount_no_decimals': return group(c, 0, ',', '.');
          case 'amount_no_decimals_with_comma_separator': return group(c, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return group(c, 2, "'", '.');
          default: return group(c, 2, '.', ',');
        }
      });
    };

    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-dk-item]'));
    var qty = function (r) { return +r.querySelector('output').value; };
    var setQty = function (r, v) { r.querySelector('output').value = v; };
    var count = function () { return rows.reduce(function (s, r) { return s + qty(r); }, 0); };
    var tierFor = function (n) {
      var t = { n: 0, p: 0 };
      tiers.forEach(function (x) { if (n >= x.n) t = x; });
      return t;
    };
    var nextTier = function (n) {
      for (var i = 0; i < tiers.length; i++) if (tiers[i].n > n && tiers[i].p > tierFor(n).p) return tiers[i];
      return null;
    };

    function update() {
      var n = count(), sub = 0;
      rows.forEach(function (r) {
        var q = qty(r);
        sub += q * +r.dataset.price;
        r.classList.toggle('is-zero', q === 0);
        r.querySelector('[data-dk-minus]').disabled = q === 0 || n <= 1;
        r.querySelector('[data-dk-plus]').disabled = q >= MAX;
      });
      var t = tierFor(n), disc = Math.round(sub * t.p / 100), total = sub - disc;
      root.querySelectorAll('[data-dk-tier]').forEach(function (b) {
        b.classList.toggle('is-on', +b.dataset.n === t.n);
        b.setAttribute('aria-pressed', +b.dataset.n === t.n ? 'true' : 'false');
      });
      root.querySelectorAll('[data-dk-sub]').forEach(function (e) { e.textContent = fmt(sub); });
      root.querySelectorAll('[data-dk-disc]').forEach(function (e) { e.textContent = '−' + fmt(disc); });
      root.querySelectorAll('[data-dk-disc-row]').forEach(function (e) { e.hidden = disc <= 0; });
      root.querySelectorAll('[data-dk-disc-label]').forEach(function (e) { e.textContent = 'Paket indirimi (%' + t.p + ')'; });
      root.querySelectorAll('[data-dk-total]').forEach(function (e) { e.textContent = fmt(total); });
      root.querySelectorAll('[data-dk-count]').forEach(function (e) { e.textContent = n + ' kitap' + (t.p ? ' · %' + t.p + ' indirim' : ''); });
      var nx = nextTier(n), nudge = root.querySelector('[data-dk-nudge-text]'), meter = root.querySelector('[data-dk-meter]');
      if (nudge) {
        if (nx) {
          var add = nx.n - n;
          nudge.innerHTML = '<b>' + add + ' kitap daha</b> ekleyin, indiriminiz <b>%' + nx.p + '</b>’e çıksın.';
        } else {
          nudge.innerHTML = 'En yüksek indirimi yakaladınız: <b>' + fmt(disc) + '</b> tasarruf.';
        }
      }
      if (meter && tiers.length) {
        var top = tiers[tiers.length - 1].n;
        meter.style.width = Math.min(100, n / top * 100) + '%';
      }
      var box = form.querySelector('[data-dk-inputs]');
      if (box) {
        box.innerHTML = '';
        rows.filter(function (r) { return qty(r) > 0; }).forEach(function (r, i) {
          box.insertAdjacentHTML('beforeend', '<input type="hidden" name="items[' + i + '][id]" value="' + r.dataset.variant + '"><input type="hidden" name="items[' + i + '][quantity]" value="' + qty(r) + '">');
        });
      }
      var main = rows.filter(function (r) { return r.hasAttribute('data-main'); })[0];
      root.querySelectorAll('[data-dk-pf-qty]').forEach(function (inp) { inp.value = main ? Math.max(1, qty(main)) : 1; });
    }

    rows.forEach(function (r) {
      r.querySelector('[data-dk-minus]').addEventListener('click', function () {
        if (qty(r) > 0 && count() > 1) { setQty(r, qty(r) - 1); update(); }
      });
      r.querySelector('[data-dk-plus]').addEventListener('click', function () {
        if (qty(r) < MAX) { setQty(r, qty(r) + 1); update(); }
      });
    });

    function applyTier(n) {
      rows.forEach(function (r) { setQty(r, r.hasAttribute('data-main') ? n : 0); });
      update();
    }
    root.querySelectorAll('[data-dk-tier]').forEach(function (b) {
      b.addEventListener('click', function () { applyTier(+b.dataset.n); });
    });

    root.querySelectorAll('[data-dk-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        var r = rows.filter(function (x) { return x.dataset.variant === b.dataset.dkAdd; })[0];
        if (!r) return;
        if (qty(r) < MAX) setQty(r, qty(r) + 1);
        update();
        r.classList.remove('dk-flash'); void r.offsetWidth; r.classList.add('dk-flash');
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var items = rows.filter(function (r) { return qty(r) > 0; }).map(function (r) { return { id: +r.dataset.variant, quantity: qty(r) }; });
      if (!items.length) return;
      var btn = form.querySelector('[type=submit]'), err = form.querySelector('[data-dk-error]');
      var back = (form.querySelector('[name=return_to]') || {}).value || base + 'cart';
      btn.disabled = true; if (err) err.hidden = true;
      fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw new Error(j.description || j.message || 'Ürün sepete eklenemedi.');
            window.location.href = back;
          });
        })
        .catch(function (x) {
          btn.disabled = false;
          if (x instanceof TypeError) { form.submit(); return; }
          if (err) { err.textContent = x.message; err.hidden = false; }
        });
    });

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-dk-stage] img'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.dk-thumb'));
    thumbs.forEach(function (b, i) {
      var go = function () {
        slides.forEach(function (img, k) { img.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (x, k) { x.classList.toggle('is-on', k === i); });
      };
      b.addEventListener('click', go);
      b.addEventListener('mouseenter', function () { if (slides[i]) slides[i].loading = 'eager'; });
    });
    var warm = function () { slides.forEach(function (img) { img.loading = 'eager'; }); };
    if (document.readyState === 'complete') setTimeout(warm, 300); else window.addEventListener('load', function () { setTimeout(warm, 300); });

    root.querySelectorAll('[data-dk-scroll]').forEach(function (b) {
      b.addEventListener('click', function () { form.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    });

    var sticky = root.querySelector('[data-dk-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }).observe(form);
    }

    var rv = root.querySelectorAll('[data-dk-reveal]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      rv.forEach(function (el) { io.observe(el); });
    } else { rv.forEach(function (el) { el.classList.add('is-in'); }); }

    update();
  }
  function boot() { document.querySelectorAll('[data-dk-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
